import { render, staticRenderFns } from "./CalenderEvent.vue?vue&type=template&id=42036e32"
import script from "./CalenderEvent.vue?vue&type=script&lang=js"
export * from "./CalenderEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports